import React, { useEffect, useState } from "react";

const ConfirmResetModal = (props) => {
  const [ItemDetails, setItemDetails] = useState();
  const [Type, setType] = useState("");

  useEffect(() => {
    if (props.RequestedItem.position) {
      setItemDetails(props.RequestedItem.position);
      setType("job");
    } else if (props.RequestedItem.project) {
      setItemDetails(props.RequestedItem.project);
      setType("project");
    } else {
      setItemDetails(props.RequestedItem.activity);
      setType("activity");
    }
  }, []);

  const shortenTitle = (Title) => {
    if (window.innerWidth <= 450) {
      if (Title.length < 24) {
        return Title;
      } else {
        return Title.slice(0, 20) + " ...";
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1450) {
      if (Title.length < 30) {
        return Title;
      } else {
        return Title.slice(0, 26) + " ...";
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1960) {
      if (Title.length < 40) {
        return Title;
      } else {
        return Title.slice(0, 36) + " ...";
      }
    }
  };
  const handleDisplayPopup = () => {
    if (window.innerWidth <= 450) {
      if (ItemDetails.title.length < 24) {
        return null;
      } else {
        return <p className="popup-text">{ItemDetails.title}</p>;
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1450) {
      if (ItemDetails.title.length < 35) {
        return null;
      } else {
        return <p className="popup-text">{ItemDetails.title}</p>;
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1960) {
      if (ItemDetails.title.length < 45) {
        return null;
      } else {
        return <p className="popup-text">{ItemDetails.title}</p>;
      }
    }
  };
  return (
    <div className="cancel-verification-modal-overlay">
      <div className="outline" onClick={() => props.Close()}></div>
      <div className="verification-modal verify-interview">
        <section className="modal-head">
          {ItemDetails === undefined ? null : (
            <span>
              <h1>{shortenTitle(ItemDetails.title)}</h1>
              {handleDisplayPopup()}
              <p>{ItemDetails.workCity}</p>
            </span>
          )}
          <i onClick={() => props.Close()} className="feather-x"></i>
        </section>
        <section className="modal-body">
          <h1>Are you sure that you want to reset the application process?</h1>
        </section>
        <section className="modal-actions interview-actions">
          <button onClick={() => props.Close()}>Discard</button>
          <button
            className="accept-interview"
            onClick={() => props.ConfirmReset()}
          >
            Reset application
          </button>
        </section>
      </div>
    </div>
  );
};

export default ConfirmResetModal;
